import ItemCard from "#src/components/items/item/ItemCard.tsx";
import { ProfileSwitchModal } from "#src/components/modals/ProfileSwitchModal.tsx";
import { useStore } from "#src/stores/Store.tsx";
import { modals } from "#src/utils/modals.ts";
import { Level } from "#types/code-generator.ts";
import { groupBy } from "es-toolkit/compat";

interface Props {}

export function ProfileSwitcher(_props: Props) {
  const store = useStore();

  function switchProfile() {
    modals.show(ProfileSwitchModal, {});
  }

  if (!store.user) {
    return null;
  }

  let level = store.user.level.toString();

  if (store.user.isAdminOrAbove) {
    level = store.organization.terminology?.administrator || "Administrator";
  } else if (store.user.isInstructor) {
    level = store.organization.terminology?.staff || "Staff";
  } else if (store.user.level === Level.AccountOwner) {
    level = store.organization.terminology?.customer || "Customer";
  }

  const userLabel = (
    <>
      <strong className="block truncate">{store.organization.title}</strong>
      <div className="truncate text-sm">
        {store.user.firstName} {store.user.lastName}, {level}
      </div>
    </>
  );

  const profiles = store.user.profile?.profiles || [];
  const profileOrgs = groupBy(profiles, (p) => p.organization.id);

  if (!store.user.profile || Object.keys(profileOrgs).length === 1) {
    return <div className="mb-2 px-4 pt-4">{userLabel}</div>;
  }

  return (
    <div className="px-4 pt-4">
      <ItemCard
        className="hover:border-darkGray flex cursor-pointer items-center gap-2 border-b-3 px-2 py-2"
        onClick={switchProfile}
      >
        <div className="full border-borderGray flex h-12 w-12 items-center justify-center rounded-full border border-b-3">
          <i className="far fa-arrows-cross text-organization" />
        </div>
        <div className="flex-1 truncate">{userLabel}</div>
      </ItemCard>
    </div>
  );
}
